import "./assets/main.css";

import { createApp } from "vue";

import ui from "@nuxt/ui/vue-plugin";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";

import { startBuildRefreshCheck } from "@ca/frontend-utils/build-refresh";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ui);
app.use(VueQueryPlugin);
app.mount("#app");

// Start after mount so the Nuxt UI toast infrastructure is ready for the stale-build prompt.
startBuildRefreshCheck(app, "sms-web");
